<template>
  <FormField
    :id="input?.id"
    :class="classField"
    :label="label"
    :isLabelVisible="isLabelVisible"
    :isError="isError"
    :errorMessage="errorMessage"
  >
    <template #label>
      <slot name="label" />
    </template>

    <input
      ref="input"
      v-bind="$attrs"
      v-uid
      :value="modelValue"
      :disabled="isDisabled"
      :type="type"
      :class="{
        isError,
        isDisabled
      }"
      @input="updateValue"
    />
  </FormField>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script setup lang="ts">
interface InputProps {
  classField?: string
  label?: string
  isLabelVisible?: boolean
  modelValue?: number | string
  isDisabled?: boolean
  isError?: boolean
  errorMessage?: string
  type?: 'text' | 'email' | 'hidden' | 'search' | 'number' | 'tel' | 'url'
}

withDefaults(defineProps<InputProps>(), {
  isLabelVisible: true,
  modelValue: '',
  type: 'text',
  isDisabled: false,
  isError: false
})

const emit = defineEmits(['update:modelValue'])

const updateValue = (e: Event) => {
  emit('update:modelValue', (e.target as HTMLInputElement).value)
}

const input = ref<null | HTMLElement>(null)
</script>
